import { ArrayDataStore } from "Stores/RESTStoreInstances/ArrayDataStore";
import { projectsDataStore } from "Stores";
import { computed, makeObservable } from "mobx";

export class QACategoriesStore extends ArrayDataStore<API_Category> {
  constructor() {
    super();

    makeObservable(this, {
      activeCategories: computed,
    });

    this.data = [] as ArrayDataStore<API_Category>["data"];
  }

  url(id?: number) {
    if (id) {
      return `api/projects/${projectsDataStore.projectId}/qa/categories/${id}`;
    } else {
      return `api/projects/${projectsDataStore.projectId}/qa/categories`;
    }
  }

  get activeCategories() {
    return this.data.filter((val) => val.active);
  }
}

export const qaCategoriesStore = new QACategoriesStore();
